import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';

export const getLocationTabNavigationProps = carrierData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
    mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
    requestParams: {
      operator: rowInfo.row['postalOperator'], // eslint-disable-line
      carriers: carrierData.carriers,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id,
    ],
  } : {}
);


export default (data, carrierData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Postal operator', 'postalOperator').withTotalHeader('Total', 'bg-total-grey'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'receptacles.total').withTotalHeader(sumTotal, 'bg-total-grey'), getLocationTabNavigationProps(carrierData)),
        new NonZeroNumberColumn('LHOT origin', 'receptacles.lhotOrigin').withTotalHeader(sumTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('LHOT destination', 'receptacles.lhotDestination').withTotalHeader(sumTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('Contract reference', 'receptacles.contractReference').withTotalHeader(sumTotal, 'bg-total-grey'),
        new NonZeroNumberColumn('Booking reference (PAWB)', 'receptacles.bookingReference').withTotalHeader(sumTotal, 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
        requestParams: {
          isTotal: true,
          operator: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
